import React, { useEffect, useState } from "react";
import { DatePicker, Input, TextArea } from "common/InputForm";
import { FaPlus } from "react-icons/fa";
import Multiselect from "multiselect-react-dropdown";
import { toastMessage } from "utils/toastMessage";
import { getUSerListApi, sendNotificationApi } from "services/notification";
import { dateFormat, getMinTime } from "utils/dateFormat";
import useButtonLoader from "common/UseButtonLoader";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import MultiSelectAll from "./MultiSelectAll";
const AddNotification = ({ getNotificationList = () => {} }) => {
  const notificationType = [
    { value: "all", label: "Send to All" },
    { value: "free", label: "Free Users" },
    { value: "premium", label: "Premium Users" },
  ];
  const [schedule, setSchedule] = useState(false);
  const [errors, setErrors] = useState({});
  const [userList, setUserList] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [buttonLoaders, setButtonLoaders] = useButtonLoader(
    schedule ? "schedule" : "Submit"
  );
  const [inputData, setInputData] = useState({
    message: "",
    title: "",
    scheduledDate: "",
    scheduleTime: "",
  });
  const [selectedUserType, setSelectedUserType] = useState("all");
  //------------validation--------------
  const validation = () => {
    let status = true;
    let errorMessage = {};
    if (!inputData?.title) {
      errorMessage["title"] = "Please enter title";
      status = false;
    }
    if (!inputData?.message) {
      errorMessage["message"] = "Please enter message";
      status = false;
    }
    if (schedule && !inputData?.scheduledDate) {
      errorMessage["scheduledDate"] = "Please select date";
      status = false;
    }
    if (schedule && !inputData?.scheduleTime) {
      errorMessage["scheduleTime"] = "Please enter time";
      status = false;
    }
    setErrors(errorMessage);
    return status;
  };
  const handleInputChange = (e) => {
    const { name, value, type, id } = e.target;
    if (type === "radio") {
      setInputData((prevData) => ({ ...prevData, userType: id }));
    } else {
      setInputData((prevData) => ({ ...prevData, [name]: value }));
    }
  };

  // ----------Handle-date-selection---------
  const handleDateChange = (date) => {
    setInputData((prevData) => ({
      ...prevData,
      scheduledDate: date,
      scheduleTime: "",
    }));
  };
  //----------Handle-time-selection------------
  const handleTimeChange = (e) => {
    const selectedTime = e.target.value;
    const minTime = getMinTime(inputData.scheduledDate);
    // Prevent selection of past time
    if (selectedTime < minTime) {
      toastMessage("Cannot select past time!", "error", "timeSelect");
      return; // Do not update state, so the user can't select an invalid time
    } else {
      setInputData((prevData) => ({ ...prevData, scheduleTime: selectedTime }));
    }
  };
  // ------------user-listing-----------------
  useEffect(() => {
    const userList = async (selectedUserType) => {
      try {
        const sendData = {
          userType: selectedUserType || "all",
        };
        console.log(sendData);
        const res = await getUSerListApi(sendData);
        if (res?.data?.status === 200) {
          const user = res?.data?.data?.users;
          console.log(user, "user");
          // setUserList(user?.map((user) => ({ key: user.name, id: user._id, })));
          setUserList(
            user.map((u) => ({
              label: `${u.name} | ${u.email} | ${u.mobile} | ${dateFormat(
                u.createdAt
              )}`,
              value: u._id,
              image:
                u.profile ||
                "https://ride-chef-dev.s3.ap-south-1.amazonaws.com/Slayrobe_App/assets/app-icon.png",
            }))
          );
        } else {
          toastMessage(res?.data?.message, "error", "userList");
        }
      } catch (e) {
        toastMessage(e.message, "error", "userList");
      }
    };
    userList(selectedUserType);
  }, [selectedUserType]);
  //--------------send-Notification-----------------
  const sendNotification = async (e) => {
    e.preventDefault();
    if (validation()) {
      setButtonLoaders(true);
      try {
        const selectedUserIds = selectedOptions.map((user) => user.value);
        const isAllSelected = selectedOptions.length === userList.length;
        const isNoneSelected = selectedUserIds.length === 0;
        const sendData = {
          ...inputData,
          isSchedule: schedule,
          isAllUsers: isAllSelected || isNoneSelected ? true : selectedUserIds,
        };
        const res = await sendNotificationApi(sendData);
        if (res?.data?.status === 200) {
          toastMessage(res?.data?.message, "success", "sendNotification");
          setInputData({
            message: "",
            title: "",
            scheduledDate: "",
            scheduleTime: "",
          });
          setSelectedOptions([]);
          setSchedule(false);
          getNotificationList();
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setButtonLoaders(false);
      }
    }
  };
  return (
    <div className="addClass">
      <div className="dashboard_title has_child">
        <h3>Notification Management</h3>
      </div>
      {/* <div>
        <label>Send Notification To:</label>
        <label>
          <input type="radio" name="userType" value="all" checked /> Send to All
        </label>
        <br />
        <label>
          <input type="radio" name="userType" value="free" /> Free Users
        </label>
        <br />
        <label>
          <input type="radio" name="userType" value="premium" /> Premium Users
        </label>
      </div> */}

      <div className="card">
        <div className="select-notification">
          {notificationType.map(({ value, label }) => {
            return (
              <label
                style={{
                  marginRight: "12px",
                  marginBottom: "6px",
                  fontSize: "15px",
                }}
              >
                <input
                  type="radio"
                  name="userType"
                  value={value}
                  checked={selectedUserType === value}
                  onClick={() => setSelectedUserType(value)}
                />
                {label}
              </label>
            );
          })}
        </div>

        <div className="card-body">
          <div className="form_field_wrap">
            <div className="form_field select_form_field">
              <label className="label">Select User</label>
              <MultiSelectAll
                options={userList}
                selectedOptions={selectedOptions}
                setSelectedOptions={setSelectedOptions}
              />
            </div>
          </div>
          <div className="form_field_wrap">
            <div className="form_field">
              <Input
                label="Title"
                placeholder="Enter Title"
                type="text"
                value={inputData.title}
                name="title"
                id="title"
                onChange={handleInputChange}
                error={errors.title}
                maxLength="150"
              />
            </div>
            <div className="form_field">
              <div className="form_field col-6">
                <Input
                  label="Message"
                  placeholder="Message"
                  type="text"
                  value={inputData.message}
                  name="message"
                  id="message"
                  onChange={handleInputChange}
                  error={errors.message}
                />
              </div>
            </div>
          </div>

          <div className="form_field_wrap">
            <div className="checkbox_wrap">
              <label className="">
                <input
                  type="checkbox"
                  checked={schedule}
                  onChange={(e) => setSchedule(e.target.checked)}
                />
                <span>Schedule</span>
              </label>
            </div>
          </div>

          {schedule && (
            <>
              <div className="form_field_wrap">
                <div className="form_field">
                  <DatePicker
                    label="Select Date"
                    name="date"
                    placeholder="Date"
                    selected={inputData.scheduledDate}
                    onChange={(date) => handleDateChange(date)}
                    error={errors.scheduledDate}
                    minDate={new Date()}
                    autoComplete="off"
                  />
                </div>
                <div className="form_field">
                  <Input
                    label="Select Time"
                    type="time"
                    placeholder="Enter time"
                    value={inputData.scheduleTime}
                    name="scheduleTime"
                    id="scheduleTime"
                    onChange={handleTimeChange}
                    error={errors.scheduleTime}
                    min={getMinTime(inputData.scheduledDate)}
                  />
                </div>
                <div className="form_field"></div>
              </div>
            </>
          )}
          <button
            type="button"
            ref={buttonLoaders}
            onClick={sendNotification}
            className="button"
          >
            {schedule ? "schedule" : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddNotification;
